import styled, { css } from 'styled-components';

import themeColors from '@polyai/ui/styles/config/colors';
import themeSpacing from '@polyai/ui/styles/config/spacing';

export const MAX_HEIGHT = 400;
export const Z_INDEX = 1500;

export const ActionMenuContainer = styled.section`
  position: relative;
  z-index: ${Z_INDEX};

  overflow: auto;

  width: 320px;
  max-height: ${MAX_HEIGHT}px;
  padding: ${themeSpacing.xs2} 0;

  background: ${themeColors.backgroundInverse};
  border: 1px solid ${themeColors.borderSubtleInverse};
  border-radius: ${themeSpacing.radiusMedium};
`;

export const ActionGroup = styled.div`
  & + & {
    border-top: 1px solid ${themeColors.borderSubtleInverse};
  }
`;

export const ActionGroupHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: ${themeSpacing.md1};
  padding: ${themeSpacing.xs1} ${themeSpacing.sm1};

  color: ${themeColors.iconSecondaryInverse};
`;

export const GroupLabel = styled.span`
  display: flex;
  gap: ${themeSpacing.xs1};
  align-items: center;
`;

const OptionStyles = css<{ $isSelected?: boolean }>`
  cursor: pointer;

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      background: ${themeColors.backgroundInverseHover};
    `};

  &:hover {
    background: ${themeColors.backgroundInverseHover};
  }
`;

export const CreateAction = styled.button<{ $isSelected?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: ${themeSpacing.xs1};

  border-radius: ${themeSpacing.radiusXSmall};

  ${OptionStyles}
`;

export const OptionsContainer = styled.ul`
  display: flex;
  flex-direction: column;
`;
export const Option = styled.li<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;

  width: 100%;
  padding: ${themeSpacing.xs2} ${themeSpacing.sm1};

  color: ${themeColors.textPrimaryInverse};

  ${OptionStyles}
`;
